<!-- this is not a button because checkboxes are inside -->
<div
    class="show-more-wrapper"
    [attr.role]="'button'"
    [tabIndex]="focusable ? 0 : -1"
    [class.keyboard-navigation]="focusable"
    (click)="handleActivate($event)"
    (keydown.enter)="handleActivate($event)"
    (keydown.space)="handleActivate($event)"
    [attr.aria-haspopup]="openDialog ? 'dialog' : undefined">
    <span class="show-more-text paragraph-medium bold" [attr.aria-hidden]="'true'">+{{ moreNumber }}</span>

    <span class="show-more-content">
        <ng-content></ng-content>
    </span>
</div>
